<template>
    <div>
        <div @click="showModal" class="openModalButton">
            <i class="fa-circle-plus fas fa-2xl"></i>
        </div>
        <div v-if="modalActive" class="modal" @click.self="hideModal">
            <div class="modalForm">
                <h2 class="modalTitle">Add New Question</h2>
                <div class="searchContainer">
                    <div class="formRow"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" /></div>
                    <div class="formRow">
                        <span class="inputTitle">Question Type: </span>
                        <select v-if="questionTypes" v-model="selectedQuestionType" >
                            <option value="">All</option>
                            <option v-for="qt in questionTypes" :key="qt.value" :value="qt.internalName">{{ qt.displayName }}</option>
                        </select>
                    </div>
                </div>
                <hr />
                <ListingTable v-if="questions" :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
                    :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc', pageSize: '20'}" />
                <div class="formRow">
                    <button @click="hideModal" class="cancelButton">Cancel</button>
                    <button @click="saveQuestion" class="saveButton">Add Question</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data'
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'NewSurveyQuestionModal',
    components: { ListingTable },
    props: {
        surveyId: {
            type: Number
        },
        surveyPage: {
            type: Object
        },
        onSaveQuestion: {
            type: Function
        },
        questionTypes: Array
    },
    data: function() {
        return {
            modalActive: false,
            searchText: '',
            selectedQuestionType: '',
            questions: [],
            questionIds: [],
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Description",
                    width: "35%",
                    fieldName: "description",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Question Text",
                    width: "35%",
                    fieldName: 'questionText',
                    isEditLink: true
                },
                {
                    headerDisplayName: "Question Type",
                    width: "20%",
                    fieldName: "questionType"
                }
            ],
            actionMappings: {
                onLoadData: this.getQuestions,
                onSelect: this.saveQuestion
            }
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "MultiString",
                    fieldNames: ["questionText", "description"],
                    value: this.searchText
                });

            if(this.selectedQuestionType != '') {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "questionType",
                    value: this.selectedQuestionType
                });

            }
            return criteria;
        }
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if(!this.modalActive) return;
            if (e.key == 'Escape')
                this.hideModal();
        });
    },
    methods: {
        showModal: async function() {
            if(this.surveyId && this.surveyPage) {
                await this.getQuestions();
                this.modalActive = true;
                this.componentKey++;
            }
        },
        hideModal: function() {
            this.modalActive = false;
            this.searchText = '';
            this.selectedQuestionType = '';
        },
        getQuestions: async function() {
            for(var i = 0; i < this.surveyPage.questions.length; i++) {
                if(this.questionIds.indexOf(this.surveyPage.questions[i].questionId) < 0)
                    this.questionIds.push(this.surveyPage.questions[i].questionId);
            }
            this.questions = await data.getAllQuestions(false);

            return this.questions.filter(q => {
                return this.questionIds.indexOf(q.id) < 0;
            })
        },
        saveQuestion: async function(ques) {
            var newSequence = 1; 
            if(this.surveyPage.questions && this.surveyPage.questions.length > 0)
                newSequence = this.surveyPage.questions[this.surveyPage.questions.length - 1].sequence + 1;

            const surQues = {
                sequence: newSequence,
                questionId: ques.id,
                logActivityTypeCode: 'ANSWER_QUESTION'
            }

            if(this.onSaveQuestion) {
                var result = await this.onSaveQuestion(surQues);

                if(!result.success)
                    return;
            }

            this.hideModal();
        }
    }
}
</script>

<style scoped>
    .modal {
        width: 100vw;
        position: fixed;
        top: 0px;
        left: 0px;
        backdrop-filter: blur(4px);
        padding: 100px 0 0 0;
        display: flex;
        justify-content: center;
        z-index: 1000;
    }
    .modalForm {
        border: 1px solid lightgray;
        background-color: white;
        width: 800px;
        padding: 20px;
        text-align: left;
        max-height: calc(100vh - 210px);
        overflow-y: auto;
    }
    .modalTitle {
        width: 100%;
        text-align: center;
    }
    
    .openModalButton {
        color: #036991; 
        cursor: pointer;
        margin-left: 20px;
    }

    .openModalButton:disabled {
        color: gray;
    }
    .questionsContainer {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }
    .modalForm .question {
        flex: 1 1 200px;
        min-width: 40%;
        max-width: 45%;
        padding: 10px;
        margin: 10px;
        border: 1px solid lightgray;
        cursor: pointer;
    }
    .questionSelected {
        background-color: lightblue;
    }
    .formRow {
        margin: 10px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .questionText, .questionDescription {
        width: 100%;
    }
    .questionType, .answerType {
        width: 48%;
        display: inline-block;
    }
    .modalForm .sequence {
        margin: 0 0 30px 10px;
    }
    .saveButton {
        margin-left: 170px;
        background-color: lightblue;
        height: 40px;
        width: 200px;
        border-radius: 5px;
        border-color: lightblue;
        cursor: pointer;
        font-size: 16px;
    }
    .cancelButton {
        margin-left: 100px;
        height: 40px;
        width: 200px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        cursor: pointer;
        font-size: 16px;
    }
</style>